// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 3840px){
    .footer-container{
        display: none;
    }

    .footer-copyright{
        display: flex;
        background-color: #FFBD59;
        margin-top: 10vh;
        align-items: center;
        height: 50px;
    }

    .footer-copyright p{
        margin-bottom: 0px;
        margin-left: 20px;
    }
}

@media screen and (max-width: 540px) {

    .footer-container{
        display: block;
        position: fixed;
        bottom:0;
        width: 100%;
        height: 70px;
    }

    .footer-container p {
        color: var(--footer-button-text-color);
        margin: 0px;
    }

    .footer-background{
        background: #FFBD59;
        height: 80px;
        width: 100%;
        background-position: center;
    }

    .footer-button1{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        left: 3%;
        border-radius: 40px;
        width: 50px;
        height: 50px;
        transition: all 1s;
        transform: translateY(-13%);
    }

    .footer-button1 img{
        width: 100%;
        height: 100%;
        margin-bottom: 3px;
    }

    .footer-button2{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        left: 23%;
        border-radius: 40px;
        width: 50px;
        height: 50px;
        transition: all 1s;
        transform: translateY(-7%);
    }

    .footer-button2 img{
        width: 100%;
        height: 100%;
    }

    .home-button-wrapper{
        position: absolute;
        left: 50%;
        border-radius: 50%;
        transform: translate(-50%,-30%);
        transition: all 1s;
        box-shadow: 0 0 10px #fff6;
    }

    .home-button-wrapper img{
        width: 80px;
        height: 80px;
    }

    .footer-button3{
        width: 75px;
        height: 75px;
    }

    .footer-button4{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        right: 23%;
        border-radius: 40px;
        width: 50px;
        height: 50px;
        transition: all 1s;
        transform: translateY(-7%);
    }

    .footer-button4 img{
        width: 50px;
        height: 50px;
    }

    .footer-button5{
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        right: 3%;
        border-radius: 40px;
        width: 50px;
        height: 50px;
        transition: all 1s;
        transform: translateY(-7%);
    }

    .footer-button5 img{
        width: 50px;
        height: 50px;
    }

    .footer-copyright{
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/layouts/Footer.css"],"names":[],"mappings":"AAAA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,cAAc;QACd,eAAe;QACf,QAAQ;QACR,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sCAAsC;QACtC,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,QAAQ;QACR,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;QACT,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,kBAAkB;QAClB,+BAA+B;QAC/B,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,UAAU;QACV,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;QACT,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@media screen and (max-width: 3840px){\n    .footer-container{\n        display: none;\n    }\n\n    .footer-copyright{\n        display: flex;\n        background-color: #FFBD59;\n        margin-top: 10vh;\n        align-items: center;\n        height: 50px;\n    }\n\n    .footer-copyright p{\n        margin-bottom: 0px;\n        margin-left: 20px;\n    }\n}\n\n@media screen and (max-width: 540px) {\n\n    .footer-container{\n        display: block;\n        position: fixed;\n        bottom:0;\n        width: 100%;\n        height: 70px;\n    }\n\n    .footer-container p {\n        color: var(--footer-button-text-color);\n        margin: 0px;\n    }\n\n    .footer-background{\n        background: #FFBD59;\n        height: 80px;\n        width: 100%;\n        background-position: center;\n    }\n\n    .footer-button1{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        left: 3%;\n        border-radius: 40px;\n        width: 50px;\n        height: 50px;\n        transition: all 1s;\n        transform: translateY(-13%);\n    }\n\n    .footer-button1 img{\n        width: 100%;\n        height: 100%;\n        margin-bottom: 3px;\n    }\n\n    .footer-button2{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        left: 23%;\n        border-radius: 40px;\n        width: 50px;\n        height: 50px;\n        transition: all 1s;\n        transform: translateY(-7%);\n    }\n\n    .footer-button2 img{\n        width: 100%;\n        height: 100%;\n    }\n\n    .home-button-wrapper{\n        position: absolute;\n        left: 50%;\n        border-radius: 50%;\n        transform: translate(-50%,-30%);\n        transition: all 1s;\n        box-shadow: 0 0 10px #fff6;\n    }\n\n    .home-button-wrapper img{\n        width: 80px;\n        height: 80px;\n    }\n\n    .footer-button3{\n        width: 75px;\n        height: 75px;\n    }\n\n    .footer-button4{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        right: 23%;\n        border-radius: 40px;\n        width: 50px;\n        height: 50px;\n        transition: all 1s;\n        transform: translateY(-7%);\n    }\n\n    .footer-button4 img{\n        width: 50px;\n        height: 50px;\n    }\n\n    .footer-button5{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        right: 3%;\n        border-radius: 40px;\n        width: 50px;\n        height: 50px;\n        transition: all 1s;\n        transform: translateY(-7%);\n    }\n\n    .footer-button5 img{\n        width: 50px;\n        height: 50px;\n    }\n\n    .footer-copyright{\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
